module.exports = __webpack_public_path__ + "img/section-solution.1928f14c.png";